document.addEventListener("DOMContentLoaded", function () {
    new Swiper('.resource-list-swiper', {
      slidesPerView: 1.46,
      spaceBetween: 15,
      loop: true,
      pagination: false,
      simulateTouch: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 18,
        }
      }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    new Swiper('.index-blog-card-swiper', {
      slidesPerView: 1.25,
      spaceBetween: 15,
      loop: true,
      pagination: {
      el: '.swiper-pagination',
      clickable: true
      },
      simulateTouch: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        10: {
          slidesPerView: 1.25
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        }
      }
    });
  });

 $(document).ready(function () {
  const $thumbSliderBG = $('<div class="thumb-slider-bg"></div>');
  const $thumbSlider = $('<div class="thumb-slider"></div>');
   $thumbSliderBG.append($thumbSlider);
  $('.cons_meet_our_slider > .group-block-content').after($thumbSliderBG);

  $('.cons_meet_our_slider > .group-block-content .cons_meet_our_slide_img_main').each(function () {
    const $img = $(this).find('img').first(); 
    const src = $img.attr('src');
    if (src) {
      const thumbItem = `<div><span><img src="${src}" /></span></div>`;
      $thumbSlider.append(thumbItem);
    }
  });
   
  $('.cons_meet_our_slider > .group-block-content').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.thumb-slider',
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          fade: false,
          centerMode: false,
        }
      }
    ]
  });

  $('.thumb-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.cons_meet_our_slider > .group-block-content',
    focusOnSelect: true,
    centerMode: false,
    dots: false,
    arrows: false,
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.menu-list__list-item a');
  const currentPath = window.location.pathname;
  links.forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.parentElement.classList.add('highlight_menu');
    }
  });

});

document.querySelectorAll('.custom-filter').forEach(button => {
  button.addEventListener('click', () => {
    const activeEl = document.querySelector('.icon-checkmark-active');

    if (activeEl) {
      sessionStorage.setItem('scrollTo', 'active');
    } else {
      sessionStorage.setItem('scrollTo', window.scrollY.toString());
    }
  });
});

window.addEventListener('DOMContentLoaded', () => {
  const scrollTo = sessionStorage.getItem('scrollTo');

  if (scrollTo === 'active') {
    const activeEl = document.querySelector('.icon-checkmark-active');
    if (activeEl) {
      activeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  } else if (scrollTo) {
    window.scrollTo({ top: parseInt(scrollTo), behavior: 'smooth' });
  }

  sessionStorage.removeItem('scrollTo');
});

document.addEventListener("DOMContentLoaded", function () {
  const slideshow = document.querySelector('.index-product-list .resource-list-swiper');
  if (slideshow) {
    // Wait for your slideshow to initialize fully
    setTimeout(() => {
      slideshow.classList.add('slideshow--initialized');
    }, 200); // Adjust delay as needed based on script load time
  }
});

// main menu desktop js
document.addEventListener('DOMContentLoaded', function () {
    const benefitItems = document.querySelectorAll('.benefit-item');

    benefitItems.forEach(item => {
      item.addEventListener('click', function (e) {
        // Optional: Close other open items
        benefitItems.forEach(i => {
          if (i !== item) {
            i.classList.remove('active');
          }
        });

        // Toggle current item
        item.classList.toggle('active');
      });
    });
  });